import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const finish = (ok, user) => {
      window.history.replaceState(null, '', window.location.pathname);
      if (ok) {
        localStorage.setItem('njk_admin_token', 'google-session');
        localStorage.setItem('njk_admin_user', user?.name || user?.email || 'Admin');
        localStorage.setItem('njk_admin_role', 'owner');
        navigate('/admin/tools', { replace: true, state: { user } });
      } else {
        navigate('/admin/login', { replace: true });
      }
    };

    if (!sessionId) {
      finish(false);
      return;
    }

    axios
      .post(`${API}/api/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => finish(true, res.data.user))
      .catch(() => finish(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#5c1a1a]"></div>
    </div>
  );
}
